import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('approvalmax_url_to_netsuite'),
    subtitle: defineMessage('when_should_we_update_a_ustom_field_in_netsuite'),
    afterApproval: defineMessage('after_final_approval_rejection'),
    afterSync: defineMessage('after_first_requests_sync_to_approvalmax'),
};
